import './MatchEditInputs.scss';

import { Equalizer, HighlightOff } from '@mui/icons-material';
import { TextField } from '@mui/material';
import classNames from 'classnames';
import { MatchResultEnum } from 'domain/event/match/MatchResult.enum';
import { SystemPointsEnum } from 'domain/event/SystemPoints.enum';
import { TypeEventCodeEnum } from 'domain/event/TypeEventCodeEnum';
import { SCORE_DEFAULT } from 'domain/event/UnpyEvent';
import { insertIf } from 'helper/array.helper';
import { InputRadios } from 'primary/Components/Input/InputRadios';
import {
  ChangeHandlerTypeParam,
  InputWrapper,
} from 'primary/Components/Input/InputWrapper';
import { IconPodiumByIndex } from 'primary/events/components/PodiumView';
import { useTranslate } from 'primary/hooks/useTranslate';
import React from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { UseControllerReturn } from 'react-hook-form/dist/types';

interface InputScoreProps {
  systemPoint: SystemPointsEnum;
  controlProps: UseControllerReturn<any, any>;
  controlOtherProps?: UseControllerReturn<any, any>;
  setValue: UseFormSetValue<any>;
  withoutNull?: boolean;
  errors: any;
  typeEvent?: TypeEventCodeEnum;
}

type SystemPointDefaultInputsProps = {
  errors: any;
  withoutNull?: boolean;
  controlOtherProps?: UseControllerReturn<any, any>;
  setValue: UseFormSetValue<any>;
  controlProps: UseControllerReturn<any, any>;
  typeEvent?: TypeEventCodeEnum;
};

const SystemPointDefaultInputs = ({
  controlProps,
  controlOtherProps,
  setValue,
  errors,
  withoutNull,
  typeEvent,
}: SystemPointDefaultInputsProps) => {
  const t = useTranslate();
  const isTournamentEvent =
    typeEvent &&
    [TypeEventCodeEnum.TOURNAMENT, TypeEventCodeEnum.TOURNAMENT_DOUBLE_ELEM].includes(
      typeEvent,
    );
  return (
    <div className={'systemPointDefaultInput'}>
      <InputWrapper
        className={'unpy-form__field'}
        label={t('event.matchs.edit.modal.scoreLabel')}
        errors={errors}
        Input={InputRadios}
        isSubmitting={false}
        required
        inputProps={{
          placeholder: t('event.form.placeholders.typeEvent'),
          ...controlProps.field,
          // @ts-ignore
          onChange: (e: ChangeHandlerTypeParam) => {
            controlProps.field.onChange(e);

            if (controlOtherProps && withoutNull) {
              controlOtherProps.field.onChange({
                target: {
                  value:
                    e.target.value === MatchResultEnum.WIN.toString()
                      ? MatchResultEnum.LOOSE
                      : MatchResultEnum.WIN,
                },
              });
            }
          },
          options: [
            {
              label: (
                <div className={'-inputDefeat'}>
                  <HighlightOff width={'50px'} height={'50px'} />
                  <span>
                    {t(
                      `event.matchs.edit.editScore.${
                        isTournamentEvent
                          ? 'defeatScoreDefaultLabelTournament'
                          : 'defeatScoreDefaultLabel'
                      }`,
                      {
                        points: SCORE_DEFAULT.DEFEAT,
                      },
                    )}
                  </span>
                </div>
              ),
              value: MatchResultEnum.LOOSE,
            },
            ...insertIf(!withoutNull, {
              label: (
                <div className={'-inputNull'}>
                  <Equalizer width={'50px'} height={'50px'} />
                  <span>
                    {t(
                      `event.matchs.edit.editScore.${
                        isTournamentEvent
                          ? 'nullScoreDefaultLabelTournament'
                          : 'nullScoreDefaultLabel'
                      }`,
                      {
                        points: SCORE_DEFAULT.NULL,
                      },
                    )}
                  </span>
                </div>
              ),
              value: MatchResultEnum.NULL,
            }),
            {
              label: (
                <div className={'-inputWin'}>
                  {IconPodiumByIndex[0]}
                  <span>
                    {t(
                      `event.matchs.edit.editScore.${
                        isTournamentEvent
                          ? 'winScoreDefaultLabelTournament'
                          : 'winScoreDefaultLabel'
                      }`,
                      {
                        points: SCORE_DEFAULT.WIN,
                      },
                    )}
                  </span>
                </div>
              ),
              value: MatchResultEnum.WIN,
            },
          ],
        }}
      />
    </div>
  );
};

export const InputScore = ({
  systemPoint,
  controlProps,
  setValue,
  controlOtherProps,
  errors,
  withoutNull,
  typeEvent,
}: InputScoreProps) => {
  return (
    <div className={classNames('inputScore')}>
      {systemPoint === SystemPointsEnum.DEFAULT && (
        <SystemPointDefaultInputs
          typeEvent={typeEvent}
          setValue={setValue}
          controlOtherProps={controlOtherProps}
          errors={errors}
          controlProps={controlProps}
          withoutNull={withoutNull}
        />
      )}
      {systemPoint === SystemPointsEnum.PERSO && (
        <InputWrapper
          errors={errors}
          Input={TextField}
          className={'-input'}
          inputProps={{
            ...controlProps.field,
            type: 'number',
            variant: 'filled',
            autoFocus: true,
            min: 0,
          }}
        />
      )}
    </div>
  );
};
